import { DtoRequestCarusesPostReq } from "./abst/DtoRequestCarusesPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestCarusesPostReqImple extends DtoRequestCarusesPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
